export default {
  scrollableNavigationToolbar: {
    height: '40px',
  },
};
